import {
  ArnConnectOptions,
  ArnConnectorType,
  ArnValidAuthConfig,
  AuthJwtConfig,
} from '@arianee/arn-types';

export type ArnAuthConfig = Partial<ArnValidAuthConfig>;

export class ArnAuthConfigImpl implements ArnValidAuthConfig {
  constructor(
    /**
     * The message to display when requesting the user to sign at connect time.
     */
    readonly connectorType: ArnConnectorType,
    readonly options: ArnConnectOptions,
    readonly sigMessage: string,
    readonly jwt: AuthJwtConfig,
    public autoConnect: boolean,
    readonly trySwitchChainNumber?: number
  ) {}
}
